import type { GameAssetTypesUnion } from '#imports'

export interface GameTileProps {
    game: Game
    videoEnabled?: boolean
    loadMedia?: boolean
    isInline?: boolean
    enforceVideoType?: GameTileType.VIDEO | GameTileType.VIDEO_SMALL
    isMini?: boolean
    eager?: boolean
}

export enum GameProviderSlug {
    GAMES_GLOBAL = 'games-global',
    MAGNET = 'magnet',
    EVOLUTION = 'evolution',
    PARIPLAY = 'pariplay',
    PRAGMATIC = 'pragmatic',
}

export interface Game {
    id: string
    name: string
    updated_at: string
    slug: string
    provider_slug: string
    vendor_slug: string
    sort_index: number
    tile_type: GameTileTypeUnion
    game_type: GameTypeUnion
    game_subtype: GameSubtypeUnion
    is_active: boolean
    is_new: boolean
    is_exclusive: boolean
    is_recommended: boolean
    is_staff_only: boolean
    tile_decoration?: string | null
    has_jackpot: boolean
    jackpot?: string
    superJackpot?: string
    opening_hours: GameOpeningHours
    attributes: Record<string, (string | number)>
    headline: string
    description: string
    full_description: string
    instance_id?: string
    excluded_from_bonus_funds?: boolean
    game_hero_colour?: string | null
    asset_availability?: Partial<Record<GameAssetTypesUnion, boolean | null>>
}

interface GameOpeningHours {
    is_open: boolean
    opens_at: string | number | null
}

export enum GameTileType {
    DEFAULT = 'DEFAULT',
    VIDEO = 'VIDEO',
    VIDEO_SMALL = 'VIDEO_SMALL',
    HIDDEN = 'HIDDEN'
}

export type GameTileTypeUnion = `${GameTileType}`

export enum GameType {
    CASINO = 'CASINO',
    LIVE_CASINO = 'LIVE_CASINO',
    BINGO = 'BINGO',
    SLOTS = 'SLOTS'
}

export type GameTypeUnion = `${GameType}`

export enum GameSubtype {
    LIVE = 'LIVE',
    COLLECTOR = 'COLLECTOR'
}

export type GameSubtypeUnion = `${GameSubtype}`

export type GameClickEventEmit = {
    'game-click': [game: Game]
}
